import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//styles and images
import styled from "styled-components";
import { bg, bgMobile } from "../img";
//animations
import { motion } from "framer-motion";
import { SlideAnimation } from "../styles/Animations";
//components
import Logo from "./Logo";
import BackToTopButton from "./BackToTopButton";
//languages
import { useLanguage } from "../hooks/useLanguage";
import type { LanguageProps } from "../typings";
import { colors } from "../styles/variables";

const Header = ({ language }: LanguageProps) => {
  const location = useLocation();
  const [header, setHeader] = useState("");
  const lang = useLanguage(language);

  useEffect(() => {
    if (location.pathname === "/faq") {
      setHeader(lang.faq.header);
    } else if (location.pathname === "/services") {
      setHeader(lang.services.header);
    } else if (location.pathname === "/contact") {
      setHeader(lang.contact.header);
    }
  }, [location, lang]);

  return (
    <>
      <StyledHead>
        <BackToTopButton />
        <StyledMainContainer>
          <Logo />
          <div className="title-container">
            <motion.h1 variants={SlideAnimation}>{header}</motion.h1>
          </div>
        </StyledMainContainer>
      </StyledHead>
    </>
  );
};

const StyledHead = styled.section`
  height: 55vh;
  display: flex;
  justify-content: center;
  background: url("${bg}") fixed top center no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  -moz-background-size: 100% auto;
  -o-background-size: 100% auto;
  position: relative;
  color: ${colors.white};
  overflow: hidden;
  @media all and (max-width: 967px) {
    height: 40vh;
    background-image: url("${bgMobile}");
    background-position: center top;
    background-size: 100% auto;
    background-attachment: fixed;
  }
`;

const StyledMainContainer = styled.div`
  min-height: 100%;
  width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  .title-container {
    margin-top: 15rem;
    border-top: 2px solid ${colors.white};
    width: 100%;
    height: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media all and (max-width: 2000px) {
    .title-container {
      height: 20%;
      margin-top: 3rem;
    }
  }
  @media all and (max-width: 1600px) {
    width: 1000px;
    h1 {
      font-size: 3rem;
      padding: 1rem 0;
    }
  }
  @media all and (max-width: 1144px) {
    width: 90vw;
  }
  @media all and (max-width: 768px) {
    width: 95vw;
    h1 {
      font-size: 1.5rem;
    }
  }
`;

export default Header;
